export enum ConsciousLevel {
  ALERT = 'Alert',
  VPU = 'VPU'
}

export enum OxygenScale {
  SCALE_1 = 'Scale 1',
  SCALE_2 = 'Scale 2'
}

export type OxygenTherapy = 'Air' | 'Oxygen';
export type RiskTone = 'normal' | 'low' | 'medium' | 'high';

export type SituationId =
  | 'acute-presentation'
  | 'inpatient-deterioration'
  | 'suspected-infection'
  | 'respiratory-deterioration'
  | 'new-confusion'
  | 'ongoing-monitoring';

export interface ClinicalSituation {
  id: SituationId;
  title: string;
  summary: string;
  caseDescription: string;
  vitals: NEWS2State;
  sourceUrl: string;
}

export interface NEWS2State {
  respirationRate: number;
  oxygenSaturation: number;
  airOrOxygen: OxygenTherapy;
  systolicBP: number;
  pulseRate: number;
  consciousness: ConsciousLevel;
  temperature: number;
  oxygenScale: OxygenScale;
}

export interface ScoreBand {
  min?: number;
  max?: number;
  score: 0 | 1 | 2 | 3;
  label: string;
}

export interface ScoreResult {
  total: number;
  tone: RiskTone;
  riskLevel: 'Maža' | 'Vidutinė' | 'Aukšta' | 'Normali';
  clinicalResponse: string;
  frequencyOfMonitoring: string;
}
